var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMastercard = function SvgMastercard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 482.51 374"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ff5f00",
    d: "M181.141 88.244h121.093v197.513H181.141z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#eb001b",
    d: "M193.358 187a125.96 125.96 0 0 1 47.807-98.756 125.626 125.626 0 1 0 0 197.513A125.96 125.96 0 0 1 193.358 187"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#f79e1b",
    d: "M444.618 187a125.5 125.5 0 0 1-203.057 98.757 125.904 125.904 0 0 0 0-197.513A125.5 125.5 0 0 1 444.618 187"
  })));
};
export default SvgMastercard;